import { render, staticRenderFns } from "./2faU2F.vue?vue&type=template&id=944e8172&scoped=true&"
import script from "./2faU2F.vue?vue&type=script&lang=js&"
export * from "./2faU2F.vue?vue&type=script&lang=js&"
import style0 from "./2faU2F.vue?vue&type=style&index=0&id=944e8172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e8172",
  null
  
)

export default component.exports